import type {ValueOf} from '@myparcel-frontend/types';
import {TierName} from '@/types/subscriptions/tiers';

export const MyContractsProductId = {
  Light: 4610,
  Start: 4611,
  Plus: 4612,
  Premium: 4613,
  Max: 4614,
} as const;

export const MyContractsTierName = {
  Light: TierName.Light,
  Start: TierName.Start,
  Plus: TierName.Plus,
  Premium: TierName.Premium,
  Max: TierName.Max,
} as const;

export const MY_CONTRACTS_IDS_TO_NAMES = {
  [MyContractsProductId.Light]: MyContractsTierName.Light,
  [MyContractsProductId.Start]: MyContractsTierName.Start,
  [MyContractsProductId.Plus]: MyContractsTierName.Plus,
  [MyContractsProductId.Premium]: MyContractsTierName.Premium,
  [MyContractsProductId.Max]: MyContractsTierName.Max,
};

export const toMyContractsTierName = <T extends ValueOf<typeof MyContractsProductId>>(id: T) => {
  return MY_CONTRACTS_IDS_TO_NAMES[id];
};
